import { Grid, GridItem, Badge, Skeleton } from "@chakra-ui/react";
import { CancelSubscription } from ".";
import { useBilling } from "lib/hooks";
import { path, has }  from 'ramda';

const getLastFour = path(['payment_method', 'last_four']);
const getExpiryMonth = path(['payment_method', 'month']);
const getExpiryYear = path(['payment_method', 'year']);

const getName = path(['plan', 'name']);
const getStatus = path(['plan', 'status']);

const hasPaymentMethod = has('payment_method');

export const SubscriptionDetails = () => {
  const { data } = useBilling();

  const status = getStatus(data);

  if (!hasPaymentMethod(data)) {
    return null;
  }

  return (
    <Grid width="100%" gap="10px">
      <Skeleton isLoaded={!!data}>
        <Grid autoFlow="column" justifyContent="space-between">
            <GridItem>Plan:</GridItem>
            <GridItem>{getName(data)}</GridItem>
        </Grid>
      </Skeleton>
      <Skeleton isLoaded={!!data}>
        <Grid autoFlow="column" justifyContent="space-between">
          <GridItem>Status:</GridItem>
          <GridItem>
            <CancelSubscription />
            <Badge colorScheme={status === 'active' ? 'green' : 'red'}>{status}</Badge>
          </GridItem>
        </Grid>
      </Skeleton>
      <Skeleton isLoaded={!!data}>
        <Grid autoFlow="column" justifyContent="space-between">
          <GridItem>Card:</GridItem>
          <GridItem>xxxx xxxx xxxx {getLastFour(data)}</GridItem>
        </Grid>
      </Skeleton>
      <Skeleton isLoaded={!!data}>
        <Grid autoFlow="column" justifyContent="space-between" width="100%">
          <GridItem>Expires:</GridItem>
          <GridItem>{getExpiryMonth(data)}/{getExpiryYear(data)}</GridItem>
        </Grid>
      </Skeleton>
    </Grid>
  )
};
